module.exports = __webpack_public_path__ + "static/media/instaIcon.c8c8eebf.svg";